import { InputRadioUncontrolled } from "@/components/common/inputs";
import clsx from "clsx";
import { TdHTMLAttributes } from "react";

import { TableCell } from "../TableCell";

interface Props extends Omit<TdHTMLAttributes<HTMLTableCellElement>, "children" | "onChange"> {
  id: string;
  value: string;
  selected: string | null | undefined;
  onChange: (value: string) => void;
  disabled?: boolean;
  name?: string;
}

export const TableSelectionCell = ({
  disabled,
  id,
  name,
  onChange,
  selected,
  value,
  "aria-label": ariaLabel,
  className,
  ...props
}: Props) => {
  const isSelected = selected === value;

  return (
    <TableCell unwrapped className={clsx("[&+*]:border-l-transparent pr-0", className)} {...props}>
      <InputRadioUncontrolled
        id={id}
        aria-label={ariaLabel}
        checked={isSelected}
        disabled={disabled}
        name={name}
        value={value}
        onChange={() => onChange(value)}
      />
    </TableCell>
  );
};
